var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2312 17.7649C13.2312 18.5828 13.4733 19.3709 13.9582 20.1277C14.4426 19.4309 14.6852 18.6433 14.6852 17.7649V0.0530739C14.1938 0.0880776 13.7089 0.145313 13.2312 0.225254V17.7649Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0659 25.6916H27.1722C29.7195 22.8558 31.2767 19.1875 31.2781 15.4842C31.2804 9.16699 27.4925 3.73764 22.0659 1.33279V25.6916Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86908 17.7649C8.86908 18.5828 9.11127 19.3709 9.59612 20.1277C10.081 19.4309 10.3232 18.6433 10.3232 17.7649V1.01047C9.82553 1.19873 9.34068 1.41254 8.86908 1.64953V17.7649Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1578 28.5994V0.377472C18.6451 0.26442 18.1233 0.176437 17.5931 0.114944V17.7648C17.5931 20.0368 17.0179 21.7028 13.9583 24.066C12.6254 23.0357 12.2919 22.7633 11.7768 22.0665C11.4135 22.5812 10.6864 23.2481 9.59612 24.066C6.99071 22.006 5.96094 20.34 5.96094 17.7648V3.54058C2.52017 6.37919 0.326767 10.6752 0.326767 15.4839C0.326767 24.031 7.25561 30.9598 15.8027 30.9598C18.7065 30.9598 21.4236 30.0743 23.7452 28.5994H19.1578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWLogo);
export default __webpack_public_path__ + "static/media/WLogo.c8ef882bbb1d9119aa389171ecb54662.svg";
export { ForwardRef as ReactComponent };